import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import EmptyLayout from "../components/EmptyLayout";
import LayoutRoute from "../components/LayoutRouter";
import ScrollTop from "./scrollTop";
import { BeatLoader } from "react-spinners";

// images
import logoPM from "../images/logo-pinjam-modal.svg";

// pages
const Homepage = lazy(() => import("../pages/homepage"));
const HowToPay = lazy(() => import("../pages/cara_bayar"));
const DetailHowToPay = lazy(() => import("../pages/cara_bayar/detail"));

export default function App() {
  return (
    <Router>
      <Suspense
        fallback={
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <img src={logoPM} alt="" />
            <div className="pt-3 d-flex justify-content-center">
              <BeatLoader color="#007edc" size="12px" />
            </div>
          </div>
        }
      >
        <ScrollTop>
          <Switch>
            <LayoutRoute
              exact
              path="/"
              layout={EmptyLayout}
              component={Homepage}
            />
            <LayoutRoute
              exact
              path="/cara-bayar/:method/:loanid"
              layout={EmptyLayout}
              component={DetailHowToPay}
            />
            <LayoutRoute
              exact
              path="/cara-bayar/:method"
              layout={EmptyLayout}
              component={HowToPay}
            />
          </Switch>
        </ScrollTop>
      </Suspense>
    </Router>
  );
}
